import { UserRole } from '@mi-front/core';
import { useIntl } from 'react-intl';
import { userRoleDescriptionMessages, userRoleLabelMessages } from '../messages';
import { userRoleIconMap } from './UserRoleIconMap';

export function UserRoleInfo({
  value,
  display = 'long',
}: {
  value: UserRole;
  display?: 'long' | 'short';
}) {
  const { formatMessage } = useIntl();

  return (
    <div>
      <div>
        {userRoleIconMap[value]} {formatMessage(userRoleLabelMessages[value])}
      </div>
      {display === 'long' && (
        <div>
          <small>{formatMessage(userRoleDescriptionMessages[value])}</small>
        </div>
      )}
    </div>
  );
}
